/** @jsx jsx */
import { Plural } from '@lingui/macro';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';

export default function ProductHighlightsFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  ...rest
}) {
  // Don't show 'None'
  const filteredValues = allValues?.filter((item) => {
    return item.value !== 'None';
  });
  return (
    <DefaultFacet
      multiSelect
      title={
        <Plural
          value={filteredValues?.length}
          one="# highlight"
          other="# highlights"
        />
      }
      allValues={filteredValues}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}
